import { QueryFunction, useQuery } from 'react-query';
import { getAllWasteProducers, getWasteProducerById, GetWasteProducersQueries, WasteProducer } from '../../services/apiSLTP/sites/wasteProducers';

type UseWasteProducersQueryOptions = {
    queries?: GetWasteProducersQueries;
};

const getWasteProducers: QueryFunction<WasteProducer[]> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseWasteProducersQueryOptions];
    const { queries } = options;

    const response = await getAllWasteProducers(queries);
    return response.data;
};

export const useWasteProducersQuery = (options: UseWasteProducersQueryOptions = {}) => {
    return useQuery(['wasteProducers', options], getWasteProducers);
};

type UseWasteProducerByIdQueryOptions = {
    id: string;
    enabled?: boolean;
};

const getWasteProducerByIdQuery: QueryFunction<WasteProducer> = async ({ queryKey }) => {
    const [, options] = queryKey as [string, UseWasteProducerByIdQueryOptions];
    const { id } = options;

    const response = await getWasteProducerById(id);
    return response.data;
};

export const useWasteProducerByIdQuery = (options: UseWasteProducerByIdQueryOptions) => {
    return useQuery(['wasteProducer', options], getWasteProducerByIdQuery, {
        enabled: options.enabled !== false && !!options.id,
    });
};
